export default __webpack_public_path__ + "static/media/linkIcon.7db66e4b.svg";